import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";

import Home from "./pages/Home";

import AdminLogin from "./pages/AdminLogin";
import Dashboard from "./pages/Dashboard";

import CreateCategory from "./pages/CreateCategory";
import ManageCategories from "./pages/ManageCategories";
import EditCategory from "./pages/EditCategory";

import CreateExam from "./pages/CreateExam";
import ManageExams from "./pages/ManageExams";
import EditExam from "./pages/EditExam";

import Exams from "./pages/Exams";
import ExamDetails from "./pages/ExamDetails";

import CreateAd from "./pages/CreateAd";
import ManageAds from "./pages/ManageAds";
import EditAd from "./pages/EditAd";

import Categories from "./pages/Categories";
import About from "./pages/About";
import Contact from "./pages/Contact";

import PaymentPage from "./pages/PaymentPage";
import PaymentSuccess from "./pages/PaymentSuccess";

import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";

import ProtectedRoute from "./components/ProtectedRoute";

function App() {

  return (

    <BrowserRouter>

      <Routes>

        {/* Client Home */}

        <Route
          path="/"
          element={<Home />}
        />

        {/* Admin Login */}

        <Route
          path="/admin"
          element={<AdminLogin />}
        />

        {/* Dashboard */}

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        {/* Categories */}

        <Route
          path="/categories/create"
          element={
            <ProtectedRoute>
              <CreateCategory />
            </ProtectedRoute>
          }
        />

        <Route
          path="/categories/manage"
          element={
            <ProtectedRoute>
              <ManageCategories />
            </ProtectedRoute>
          }
        />

        <Route
          path="/categories/edit/:id"
          element={
            <ProtectedRoute>
              <EditCategory />
            </ProtectedRoute>
          }
        />

        {/* Exams (Admin) */}

        <Route
          path="/exams/create"
          element={
            <ProtectedRoute>
              <CreateExam />
            </ProtectedRoute>
          }
        />

        <Route
          path="/exams/manage"
          element={
            <ProtectedRoute>
              <ManageExams />
            </ProtectedRoute>
          }
        />

        <Route
          path="/exams/edit/:id"
          element={
            <ProtectedRoute>
              <EditExam />
            </ProtectedRoute>
          }
        />



        {/* Ads */}

        <Route
          path="/ads/create"
          element={
            <ProtectedRoute>
              <CreateAd />
            </ProtectedRoute>
          }
        />

        <Route
          path="/ads/manage"
          element={
            <ProtectedRoute>
              <ManageAds />
            </ProtectedRoute>
          }
        />

        <Route
          path="/ads/edit/:id"
          element={
            <ProtectedRoute>
              <EditAd />
            </ProtectedRoute>
          }
        />

        {/* Client Pages */}

        <Route
          path="/exams"
          element={<Exams />}
        />

        <Route
          path="/exam/:id"
          element={<ExamDetails />}
        />

        <Route
          path="/categories"
          element={<Categories />}
        />

        <Route
          path="/about"
          element={<About />}
        />

        <Route
          path="/contact"
          element={<Contact />}
        />
       <Route
         path="/privacy-policy"
         element={<PrivacyPolicy />}
       />
       <Route
         path="/terms"
         element={<Terms />}
       />
        {/* Payments */}

        <Route
          path="/payment/:id"
          element={<PaymentPage />}
        />

        <Route
          path="/payment-success"
          element={<PaymentSuccess />}
        />

      </Routes>

    </BrowserRouter>

  );

}

export default App;
